module.exports = __webpack_public_path__ + "img/browser-error.30a1c067.png";